<template>
<div id="invoice_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">

            <div class="page-name">
                <span class="page-title" id="invoiceHeader">Refund Payment List</span>
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
            </div>
            <div class="container-fluid">
              <!--div class="admin-page-content contract-crud"-->
                <section class="internal-container border-top-table-fl">
                    <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CustomerStatementForm">
                        <div v-show="enableEmail" class="form-row ">
                            <div class="col-md-4 form-group">
                                <label class="control-label" for="cycle">Email:</label>
                                <textarea class="form-control rounded-0" v-model="email" placeholder="Please Enter Email" ref="textarea" id="exampleFormControlTextarea2" rows="3"></textarea>
                                <!--input type="text" class="form-control" v-model="email" id="email" placeholder="Enter Email" name="email" data-info="Please enter email" data-val="EMAIL"-->
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="alert alert-warning hide col-sm-6" id="alertError">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <strong id="errorMsg" class="field-error"></strong>
                            </div>
                        </div>
                    </form>
                    <div v-show="!enableEmail" class="admin-page-content refund-payment-list">
                        <data-table-filter-config :moduleName="'customerRefundList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'customerList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listCustomerTable"
                                    mode="remote"
                                    title="Refund Payment List"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        setCurrentPage:listCurrentPage,
                                        perPage: perPage,
                                    }"
                                    :select-options="{
                                    enabled: canDeleteCustomer,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows" >
                                        <div :key="key" v-if="hideButton == false">
                                            <div v-if="props.column.field == 'action'">
                                                <div slot="selected-row-actions">
                                                    <button title="Print Refund Statement" v-on:click.prevent="printRefundStatment(props.row.id)" class="btn btn-primary" style="padding-right: 3px;">
                                                    <i class="fp-print"></i></button>

                                                    <button title="Send Refund Statement" v-on:click.prevent="sendEmail(props.row.id)" class="btn btn-primary" style="padding-right: 3px;">
                                                    <i class="fp-send-message" style="font-size:20px;"></i></button>

                                                    <!-- <button v-if="canProcessRefund == true && (props.row.invoice_status != 'Approved' && props.row.invoice_status != 'Confirmed' && props.row.invoice_status != 'Closed' && props.row.invoice_status != 'In progress' && props.row.invoice_status != 'Paid')" title="Revert Refund" v-on:click.prevent="refundDelete(props.row.id, props.row.refund_payment_id)" class="btn btn-danger" style="padding-right: 3px;"> -->
                                                        <button v-if="canProcessRefund == true && (props.row.status == 'ENTRY')" title="Revert Refund" v-on:click.prevent="refundDelete(props.row.id, props.row.refund_payment_id)" class="btn btn-danger" style="padding-right: 3px;">
                                                    <i class="fp-import"></i></button>
                                                </div>
                                            </div>
                                            <div v-else-if="props.column.field == 'code'">
                                                <router-link v-if="canViewCustomer" title="View Customer" class="color-blue" v-bind:key="'action_view' + key" v-bind:to="{name: 'CustomerView',params:{id:props.row.id},query:{fromUrl:fromUrl}}">{{props.row.code}}</router-link>
                                            </div>
                                            <div v-else-if="props.column.field == 'invoice_number'">
                                                <!--router-link v-if="canViewCustomer" title="View Customer" class="color-blue" v-bind:key="'action_view' + key" v-bind:to="{name: 'CustomerView',params:{id:props.row.id},query:{fromUrl:fromUrl}}">{{props.row.invoice_number}}</router-link-->
                                                <router-link title="View Vendor Invoice" target="_blank" class="color-blue" v-bind:to="{name: 'BillView',params:{id:props.row.invoice_id}}">{{props.row.invoice_number}}</router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="canProcessRefund == true && showProcessBtn == true" id="refund" v-on:click.prevent="refundProcessedMultiple()" class="btn btn-primary">Process</button>
                                        <button id="send" v-on:click.prevent="sendEmailMultiple()" class="btn btn-primary">Send</button>
                                        <button id="print" v-on:click.prevent="printRefundStatmentMultiple()" class="btn btn-primary">Download</button>
                                    </div>
                                    <!-- commented delete button because customer is used in other modules also -->
                                    <!-- <div slot="selected-row-actions">
                                        <button v-if="canDeleteCustomer" id="deleteCustomerBtn" v-on:click.prevent="customerDelete" class="btn btn-danger">Delete</button>
                                    </div> -->
                                </vue-good-table>

                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                    <div class="btn-groups" v-if="enableEmail">
                        <button type="submit" id="customerStatementSendBtn" class="btn btn-primary" v-on:click.prevent="customerStatementSend" :disabled="email == ''">
                            <i class="fp-reload"> </i>  Send
                        </button>
                        <button type="submit" id="cancelCardRateHeaderBtn" class="btn btn-tertiary" v-on:click.prevent="cancelStatement()">
                            <i class="fp-close"> </i>  Cancel
                        </button>
                    </div>
                </section>
              <!--/div-->
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>

</template>

<script>
import Vue from "vue";

import { commonMixins } from "../../../mixins/commonMixins";
import {contractMixins} from '../../../mixins/contractMixins';

import { dataTableMixins } from '../../../mixins/dataTableMixins';


import EventBus from "../../event-bus";
export default {
  name: "RefundPaymentList",
    metaInfo() {
        return {
            title: "Refund Payment List | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,contractMixins,dataTableMixins],
    data: () => ({
        pageKey: '_refund_payment_list_',
        selectedCustomerId: [],
        email: '',
        enableEmail: false,
        hideButton: false,
        permissions: [],
        cantAccessPage: "",
        loading:false,
        columns: [
            {
                label: 'Customer Code',
                field: 'code',
                filterable: true,
                fpFieldType:"text",
                width:'140px',
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterFn: this.onColumnFilter,
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer Name',
                field: 'name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Vendor Id',
                field: 'vendor_id',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor Id", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Invoice Number',
                field: 'invoice_number',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Invoice Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable: false,
            },
            {
                label: 'Invoice Status',
                field: 'invoice_status',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Invoice Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Batch',
                field: 'batch',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Batch", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems:["ENTRY","PROCESSED"]
                }
            },
            {
                label: 'Refund Amount',
                field: 'refund_amount',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                sortable:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Refund Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Actions',
                field: 'action',
                hidden:false,
                sortable: false,
            },
        ],
        rows: [],
        totalRecords: 0,
        canDeleteCustomer:false,
        canUpdateCustomer:false,
        canViewCustomer:false,
        canAddCustomerContact:false,
        fromUrl:"",
        canProcessRefund:"",
        showProcessBtn: false,
    }),
    watch:{
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'refund_payment_list') {
                      self.cantAccessPage = true;
                  } else if (permissions[i].name == 'view_customer') {
                      self.canViewCustomer = true;
                  } else if (permissions[i].name == 'add_customer') {
                      self.canUpdateCustomer = true;
                      self.canAddCustomer = true;
                  } else if (permissions[i].name == 'add_customer_contact') {
                      self.canAddCustomerContact = true;
                  } else if (permissions[i].name == 'delete_customer') {
                      self.canDeleteCustomer = true;
                  } else if (permissions[i].name == 'refund_process') {
                      self.canProcessRefund = true;
                  }
              }
          }
      },
      email: function (email) {
        console.log(this.validEmail(email));
      }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.fromUrl = btoa(window.location.pathname);
        self.getPermissions();
        // self.loadList(); function called double time
    },
    methods: {
      cancelAll: function (cancelAll) {
          this.$refs.listCustomerTable.unselectAllInternal();
        },
      refundProcessedMultiple() {

        var self = this;
        self.loading = true;
        var data = this.$refs['listCustomerTable'].selectedRows;
        var self = this;
        var use = [];
        for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listCustomerTable'].selectedRows[i].id)
        }
        self.selectedCustomerId = [];
        self.selectedCustomerId = use;

        $.ajax({
            url: process.env.ROOT_API + "/refund/processed",
            type: "POST",
            data: {
              customer: self.selectedCustomerId
              },
            headers: this.ajxHeaders,
            success: function (data) {

              console.log(data);
              self.loading = false;
                // if (data.status == 'success'){
                //     var link = document.createElement('a');
                //     document.body.appendChild(link);
                //     link.href = data.content;
                //     link.download = '';
                //     link.target = "_blank";
                //     link.click();
                // }
                self.loadList();
            },
            error: function (jqXHR, exception) {
              self.loading = false;
                self.modalLoading = false;
                self.reqeustSent = 0;
                self.generateStatusCodeMessage(jqXHR,true,'email-report-invoice-template-download');
            }
        });

      },
      sendEmailMultiple() {
        var data = this.$refs['listCustomerTable'].selectedRows;
        var self = this;
        var use = [];
        for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listCustomerTable'].selectedRows[i].id)
        }
        self.enableEmail = true;
        self.selectedCustomerId = [];
        self.selectedCustomerId = use;
        console.log(self.selectedCustomerId);
      },
      sendEmail(id) {
        var self = this;
        self.enableEmail = true;
        self.selectedCustomerId = [];
        self.selectedCustomerId.push(id);
        // self.selectedCustomerId = [id];
        console.log(self.selectedCustomerId);
      },
      cancelStatement:function(){
          var self = this;
          self.enableEmail = false;
      },
      customerStatementSend() {

        var self = this;
        // self.$swal({
        //       title: 'Are you sure that you want to send statement?',
        //       type: 'info',
        //       showCancelButton: true,
        //       confirmButtonText: 'Yes',
        //       cancelButtonText: 'No',
        //       showCloseButton: false,
        //       showLoaderOnConfirm: true
        // }).then((result) => {
        //     if (result.value) {
        //       self.sendEmailAction();
        //     } else {
        //       console.log("no");
        //     }
        // });
        self.sendEmailAction();
      },
      sendEmailAction() {

          var self = this;
          self.loading = true;

          $.ajax({
              url: process.env.ROOT_API + "/refund/statement/send",
              type: "POST",
              data: {
                email : self.email,
                customer : self.selectedCustomerId,
              },
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  self.enableEmail = false;
                  self.email = '';
                  self.$swal('','Email Sent Successfully','success');
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'customer-statement')
              }
          });

      },
      printRefundStatment(id) {
        var self = this;
        self.selectedCustomerId = [];
        self.selectedCustomerId.push(id);
        // self.selectedCustomerId = [id];
        console.log(self.selectedCustomerId);
        this.printDownload();
      },
      printRefundStatmentMultiple() {

        var data = this.$refs['listCustomerTable'].selectedRows;
        var self = this;
        var use = [];
        for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listCustomerTable'].selectedRows[i].id)
        }
        self.selectedCustomerId = [];
        self.selectedCustomerId = use;
        console.log(self.selectedCustomerId);
        self.printDownload();

      },
      printDownload: function() {

        var self = this;
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/refund/statement/download",
            type: "POST",
            data: {
              customer: self.selectedCustomerId,
              from:'payment'
              },
            headers: this.ajxHeaders,
            success: function (data) {
                if (data.status == 'success'){
                    var link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = data.content;
                    link.download = '';
                    link.target = "_blank";
                    link.click();
                }
                self.loadList();
            },
            error: function (jqXHR, exception) {
                self.modalLoading = false;
                self.reqeustSent = 0;
                self.generateStatusCodeMessage(jqXHR,true,'email-report-invoice-template-download');
            }
        });

      },
      refundDelete(id, refundId) {
        console.log("DELETE = ", id);
        var self = this;

        self.$swal({
              title: 'Are you sure to Revert Refund',
              type: 'info',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCloseButton: false,
              showLoaderOnConfirm: true
        }).then((result) => {
            if (result.value) {
              self.deleteRefund(id, refundId);
            } else {
              console.log("no");
            }
        });
      },
      deleteRefund(id, refundId) {
        var self = this;
        self.loading = true;
        // console.log(self.customer_id.value);
        $.ajax({
            url: process.env.ROOT_API + "/refund/status",
            type: "POST",
            crossDomain: true,
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                ids: [id],
                status: 0,
                refundId: refundId,
            },
            success: function(data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                  self.loadList();
                }
            },
            error: function(jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'invoice-list');
            }
        });

      },
      selectionChanged:function(param){
          var self = this;
          self.showProcessBtn = false;
          var statusArr = [];
          if(param.selectedRows.length == 100) {
            EventBus.$emit('clear-selection', false);
          } else {
            EventBus.$emit('clear-all-flags', false);
          }
          var data = this.$refs['listCustomerTable'].selectedRows;
          for (var i = 0;i < data.length;i++) {

              // if (data[i] != undefined) {
              //     if (data[i] != null) {
                      if (data[i].status == "ENTRY") {
                        self.showProcessBtn = true;
                      } else {
                        self.showProcessBtn = false;
                      }
              //     }
              // }
          }
          //check all values in array are equal or not
          // const allEqual = arr => arr.every( v => v === arr[0] );
          // var found = allEqual(statusArr);
          // if ( found ) {
          //     if (statusArr[0] == "PROCESSED") {//Work Order Status is Closed
          //         self.showProcessBtn = true;
          //     }else{
          //         self.showProcessBtn = false;
          //     }
          // }
      },
      loadList() {
          var self = this;
          self.loading = true;

          var date = new Date();
          var offset = date.getTimezoneOffset();

          var selectedRows = [];

          if ( self.firstLoad == 1 ) {
              //because on first load list not initialize
              var data = this.$refs['listCustomerTable'].selectedRows;
              for ( var i = 0; i < data.length; i++ ) {
                  selectedRows.push(this.$refs['listCustomerTable'].selectedRows[i].id)
              }
          }

          // var fields = {
          //     page: self.serverParams.page,
          //     perPage: self.serverParams.perPage,
          //     filters: self.serverParams.columnFilters,
          //     sort: self.serverParams.sort,
          //     offset: offset,
          // };

          self.firstLoad = 1;
          $.ajax({
              url: process.env.ROOT_API + "/refund/customer/list",
              type: "POST",
              data: {
                  page: self.serverParams.page,
                  perPage: self.serverParams.perPage,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
                  offset: offset,
              },
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  console.log(data);
                  if (data.status == "success") {

                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;
                      self.filteredFlag = false;


                      // var stickyTop = $('.page-name').offset().top;

                      // $(window).scroll(function() {
                      //     var windowTop = $(window).scrollTop();

                      //     if (stickyTop < windowTop) {
                      //         $('.filters-container + .bg-white.data-table').addClass('sticky');
                      //     } else {
                      //         $('.filters-container + .bg-white.data-table').removeClass('sticky');
                      //     }
                      // });
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if ( self.action == "delete" ) {
                      self.generateStatusCodeMessage(jqXHR,true,'customer-delete-error')
                  }else if (self.action =='export')
                  {
                      self.generateStatusCodeMessage(jqXHR,true,'customer-export-error')
                  }else{
                      self.generateStatusCodeMessage(jqXHR,false,'customer-list-error')
                  }

              }
          });
      }

    }

}
</script>


// WEBPACK FOOTER //
// src/components/accounting/refund/RefundPaymentList.vue